import MultiSelectWithSearch from 'components/common/MiltiSelectSearch'
import './filters.scss'
import { Radio, Input } from 'antd'
import { useEffect, useMemo, useState } from 'react'
import FilterMenu from '../../../common/FilterMenu'

interface LiveCallsFilterMenuProps {
  onClose?: () => void
  numbersOptions: string[]
  extensionsOptions: { value: string; label: string }[]
  onApplyFilters: (filters: any) => void
  currentFilters: any
}

export default function LiveCallsFilterMenu({ 
  onClose, 
  numbersOptions, 
  extensionsOptions, 
  onApplyFilters, 
  currentFilters 
}: LiveCallsFilterMenuProps) {
  const [localFilters, setLocalFilters] = useState<any>({})

  useEffect(() => {
    setLocalFilters(currentFilters || {})
  }, [currentFilters])

  const handleFilterChange = (fieldName: string, value: any) => {
    setLocalFilters((prev: any) => ({ ...prev, [fieldName]: value }))
  }

  const handleApply = () => {
    onApplyFilters(localFilters)
    onClose?.()
  }

  const handleClear = () => {
    const cleared = Object.keys(localFilters || {}).reduce((acc: any, key: string) => {
      acc[key] = null
      return acc
    }, {})
    setLocalFilters(cleared)
  }

  const extensionOptions = useMemo(() => extensionsOptions || [], [extensionsOptions])
  const phoneNumberOptions = useMemo(() => numbersOptions?.map((n) => ({ label: n, value: n })) || [], [numbersOptions])

  return (
    <FilterMenu onClose={onClose} onApply={handleApply} onClear={handleClear}>
      <div className="filter-field">
        <div className="label">Direction</div>
        <Radio.Group
          value={localFilters.direction || null}
          onChange={(e) => handleFilterChange('direction', e.target.value)}
        >
          <Radio value={'incoming'}>Incoming</Radio>
          <Radio value={'outgoing'}>Outgoing</Radio>
          <Radio value={'local'}>Local</Radio>
        </Radio.Group>
      </div>

      <div className="filter-field">
        <div className="label">Extensions</div>
        <MultiSelectWithSearch
          className="call-center-multisearch"
          placeholder="Select Extensions"
          value={localFilters.extensions || []}
          onChange={(value) => handleFilterChange('extensions', value)}
          options={extensionOptions}
        />
      </div>

      <div className="filter-field">
        <div className="label">Caller ID Number</div>
        <Input
          placeholder="Enter caller ID number"
          value={localFilters.callerIdNumber || ''}
          onChange={(e) => handleFilterChange('callerIdNumber', e.target.value)}
        />
      </div>

      {/* Disabled for now */}
      {/* <div className="filter-field">
        <div className="label">Phone Numbers</div>
        <MultiSelectWithSearch
          className="call-center-multisearch"
          placeholder="Select Numbers"
          value={localFilters.phoneNumbers || []}
          onChange={(value) => handleFilterChange('phoneNumbers', value)}
          options={phoneNumberOptions}
        />
      </div> */}

      <div className="filter-field">
        <div className="label">Call Recording</div>
        <Radio.Group
          value={localFilters.callRecording}
          onChange={(e) => handleFilterChange('callRecording', e.target.value)}
        >
          <Radio value={'yes'}>Yes</Radio>
          <Radio value={'no'}>No</Radio>
        </Radio.Group>
      </div>
    </FilterMenu>
  )
}

